module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/b79526d7b424da1546480d23671861c7.gif";